import { useMediaQuery } from 'react-responsive';
import { BREAKPOINT } from '../theme/tokens';

/**
 * True at or below the app's single mobile breakpoint.
 *
 * Reads `BREAKPOINT.mobileMax` so this and the SCSS `mobile`/`desktop` mixins
 * can never disagree — the value used to be duplicated here and as a literal
 * `822px` across 25 stylesheets.
 */
const useMobileMediaQuery = () => useMediaQuery({ maxWidth: BREAKPOINT.mobileMax });

export default useMobileMediaQuery;
